// @core/api/endpoints/form/get_form_submission.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormSubmissionResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Get form submission
 * Retrieves a form submission by its unique identifier including all answers.
 */
export async function GetFormSubmission(
  submission_id: string,
  options?: RequestOptions
): Promise<FormSubmissionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/submissions/:submission_id`;
  requestPath = requestPath.replace(':submission_id', encodeURIComponent(submission_id));
  const requestOptions = options;
  return client.get<FormSubmissionResponse>(requestPath, { ...requestOptions });
}
